import { useMemo,useContext,useState} from 'react';
import {abi,BUSD}  from './abiHelpers'
import Web3Context from '../context/Web3Context'
import {Contract,ethers} from 'ethers'

export const address ={    
  fantom:"0x09180Eb78a3cb64Db28d058382428f6553612ee9",
  busd:"0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56"
}

export const useBUSD = ()=>{    
  const {accounts, isLoaded} = useContext(Web3Context)        
  return useMemo(async() => {
    if(!isLoaded)
    return [false,null]
    const provider =await etherJSProvider()
    const signer = provider.getSigner()    
    const contract = new Contract(address.busd,BUSD,signer)          
    return [true, contract]
    },[accounts,isLoaded])
}
export const useContract = ()=>{    
  const {accounts, isLoaded} = useContext(Web3Context)        
  return useMemo(async() => {
    if(!isLoaded)
    return [false,null]
    const provider =await etherJSProvider()
    const signer = provider.getSigner()    
    const contract = new Contract(address.fantom,abi,signer)          
    return [true, contract]
    },[accounts,isLoaded])
}


const etherJSProvider =async () => {
    const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
    return provider;  
  }

